import { render, staticRenderFns } from "./edit-feedback-scale.vue?vue&type=template&id=a03f002c&scoped=true&"
import script from "./edit-feedback-scale.vue?vue&type=script&lang=ts&"
export * from "./edit-feedback-scale.vue?vue&type=script&lang=ts&"
import style0 from "./edit-feedback-scale.vue?vue&type=style&index=0&id=a03f002c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a03f002c",
  null
  
)

export default component.exports